import { render, staticRenderFns } from "./UserRegistrationMasukanOtp.vue?vue&type=template&id=f23edb4e&scoped=true"
import script from "./UserRegistrationMasukanOtp.vue?vue&type=script&lang=js"
export * from "./UserRegistrationMasukanOtp.vue?vue&type=script&lang=js"
import style0 from "./UserRegistrationMasukanOtp.vue?vue&type=style&index=0&id=f23edb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23edb4e",
  null
  
)

export default component.exports